module.exports = __webpack_public_path__ + "img/item-icon.81a89636.png";